import React from 'react';
import { createBridgeComponent } from 'mfe-react-bridge/react17';
import { ThemeProvider } from 'mintel-react-ui';

import BaseErrorPage from './BaseErrorPage';

/** A micro-frontend Error Page for use by applications not in the App Shell */

export const MfeErrorPage = ({
  errorCode = 500,
  userName,
  accountManager,
  theme,
}: {
  /** Error code indicating the type of error.
   *
   * Available error codes are `403`, `404`, `500`, `503`
   */
  errorCode?: number;
  /** First and last name of logged in user (e.g. `John Smith`)
   *
   * Will be used for subject line in mailto link to
   * contact account manager in case of 403 error
   */
  userName?: string;
  /** Email address of account manager
   *
   * Will be used in mailto link to contact account manager in case of 403 error
   */
  accountManager?: string;
  /** Either `compere` or `default` theme for different color schemes */
  theme: 'compere' | 'default';
}): JSX.Element => (
  <ThemeProvider theme={theme}>
    <BaseErrorPage
      errorCode={errorCode}
      userName={userName}
      accountManager={accountManager}
    />
  </ThemeProvider>
);

export default createBridgeComponent({
  rootComponent: MfeErrorPage,
});
